import { OnlineService } from 'src/app/services/general/online.service';
import { UserAccounts } from 'src/app/interfaces/account';
import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { TranslateService } from '@ngx-translate/core';

import { PopupService } from 'src/app/services/general/popup.service';
import { UserService } from 'src/app/services/user/user.service';
import { ErrorService } from 'src/app/services/general/error.service';
import { AccountsListService } from 'src/app/services/accounts/accounts-list.service';
import { Transaction } from 'src/app/interfaces/transaction';

@Injectable({
  providedIn: 'root'
})
export class ReferralService implements OnInit, OnDestroy {

  /**
   * referral discount
   */
  referralDiscount = 0.05;

  /**
   * Constructor
   * @param fns angualrfire functions
   * @param translate translate service
   * @param popupService popup service
   */
  constructor(
    private fns: AngularFireFunctions,
    private translate: TranslateService,
    private userService: UserService,
    private accountsListService: AccountsListService,
    private popupService: PopupService,
    private errorService: ErrorService
  ) {
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  /**
   * Check if referral mode is available.
   * If user had subscribe / join any wedding account.
   * @returns true if referral mode is available
   */
  checkReferralMode(): boolean {
    if (this.accountsListService?.userAccountsList?.length) {
      const userAccountsList: UserAccounts[] = this.accountsListService?.userAccountsList.filter((userAccounts: UserAccounts) => {
        if (userAccounts?.accountStatus?.premium) {
          return true;
        }
        return false;
      });
      if (userAccountsList?.length) {
        return true;
      }
    }
    return false;
  }

  /**
   * validate referral code
   * @param referralCode Referral code
   * @returns  referral discount rate
   */
  async validateReferralCode(referralCode: string): Promise<number> {
    if (referralCode) {
      if (await this.validateReferralCodeCall(referralCode)) {
        return this.referralDiscount;
      }
    }
    return 0;
  }

  /**
   * Validate referral call code
   * @param referralCode referral code
   * @returns true if valid referral code
   */
  async validateReferralCodeCall(referralCode: string): Promise<boolean> {
    // if (this.onlineService.isOnline()) {
      return await this.fns.httpsCallable('validateReferralCodeCall')({
        referralCode
      }).toPromise().then(async (response: any) => {
        if (response) {
          return true;
        } else {
          this.popupService.presentAlert(this.translate.instant('REFERRAL.validation.not_found'));
        }
        return false;
      }).catch((err: any) => {
        this.popupService.presentAlert(this.translate.instant('MSG.action_error'));
        this.errorService.logError(err);
        return false;
      });
    // } else {
    //   return false;
    // }
  }

  /**
   * Generate referral code
   * @returns referral code
   */
  async generateReferralCode(): Promise<string> {
    const user = this.userService?.user;
    if (user?.uid) {
      if (user?.referralCode) {
        return user.referralCode;
      } else {
        return await this.generateReferralCodeCall(user.uid);
      }
    }
    return '';
  }

  /**
   * Generate referral code
   * @param uid UID
   * @returns generate referral code
   */
  async generateReferralCodeCall(uid: string): Promise<string> {
    // if (this.onlineService.isOnline()) {
      return await this.fns.httpsCallable('generateReferralCodeCall')({
        uid
      }).toPromise().then(async (response: any) => {
        if (response) {
          return response;
        }
        return '';
      }).catch((err: any) => {
        this.errorService.logError(err);
        return '';
      });
    // } else {
    //   return '';
    // }
  }

  /**
   * Validate referral call code
   * @param referralCode referral code
   * @returns true if valid referral code
   */
  async getTransactionListByReferralCodeCall(referralCode: string): Promise<Transaction[]> {
    // if (this.onlineService.isOnline()) {
      return await this.fns.httpsCallable('getTransactionListByReferralCodeCall')({
        referralCode
      }).toPromise().then(async (response: any) => {
        return response;
      }).catch((err: any) => {
        this.errorService.logError(err);
        return [];
      });
    // } else {
    //   return [];
    // }
  }

}
